<div class="row filtros-body">
  <div class="col" style="max-width: 150px" *ngFor="let item of data; let i = index;">
    <mdb-checkbox [checked]="item.checked" (change)="onChange($event, i, item)">
      {{item.label}}
    </mdb-checkbox>
</div>
    <!-- <div class="col" style="max-width: 150px">

        <mdb-checkbox [(ngModel)]="lunes">Lunes</mdb-checkbox>
    </div>
    <div class="col" style="max-width: 150px">
        <mdb-checkbox [(ngModel)]="martes">Martes</mdb-checkbox>
    </div>
    <div class="col" style="max-width: 150px">
        <mdb-checkbox [(ngModel)]="miercoles">Miércoles</mdb-checkbox>
    </div>
    <div class="col" style="max-width: 150px">
        <mdb-checkbox [(ngModel)]="jueves">Jueves</mdb-checkbox>
    </div>
    <div class="col" style="max-width: 150px">
        <mdb-checkbox [(ngModel)]="viernes">Viernes</mdb-checkbox>
    </div>
    <div class="col"style="max-width: 150px">
        <mdb-checkbox  [(ngModel)]="sabado" >Sábado</mdb-checkbox>
    </div>
    <div class="col" style="max-width: 150px">
        <mdb-checkbox  [(ngModel)]="domingo">Domingo</mdb-checkbox>
    </div>
    <div class="col" style="max-width: 150px">
        <mdb-checkbox  [(ngModel)]="Todos">Todos</mdb-checkbox>
    </div> -->
</div>
<br>
